<template>
  <div class="page-inner">
    <div class="ap-shopping-list" v-show="!$route.params.id">
      <div class="page-inner-header">
        <div class="page-inner-title">
          <span>我的零件清单</span>
          <button class="ap-btn-red ap-btn-red-hover1 float-right" @click="showDialog=true">新建清单</button>
        </div>
      </div>
      <div>
        <table class="table font12">
          <thead>
            <tr>
              <th style="width:246px">零件清单名称</th>
              <th style="width:100px">商品数</th>
              <th>描述</th>
              <th style="width:140px">最后编辑时间</th>
              <th style="width:140px">创建时间</th>
              <th style="width:120px"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="i in records" :key="i.id" @click="$router.push($route.path + '/' + i.id)">
              <td>{{i.name}}</td>
              <td>{{i.total}}</td>
              <td>{{i.description}}</td>
              <td>{{i.maintainedTime | toShortDateTime}}</td>
              <td>{{i.createdTime | toShortDateTime}}</td>
              <td class="text-center">
                <a class="btn btn-sm btn-icon btn-secondary">
                  <i class="fa fa-pencil-alt" append></i>
                  <span class="sr-only">Edit</span>
                </a>
                <a class="btn btn-sm btn-icon btn-secondary" style="margin-left:10px" @click.stop="remove(i.id)">
                  <i class="far fa-trash-alt"></i>
                  <span class="sr-only">Remove</span>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="!records.length" style="margin-top:30px;text-align:center">No data !</div>
    </div>
    <div v-show="$route.params.id">
      <router-view></router-view>
    </div>
    <Dialog v-if="showDialog" title="新建零件清单" class="dialog" @close="close" @callback="save" ref="dialog">
      <div class="dialog-item">
        <strong class="name">名称</strong>
        <input class="form-control" v-model="listName" />
      </div>
      <div class="dialog-item">
        <strong class="name">描述</strong>
        <input class="form-control" v-model="listDescribe" />
      </div>
    </Dialog>
  </div>
</template>

<script>
import Pagination from "@components/Pagination.vue";
import Dialog from "@components/Dialog.vue";

export default {
  components: {
    Pagination,
    Dialog
  },
  data() {
    return {
      showDialog: false,
      listName: "",
      listDescribe: "",
      records: []
    };
  },
  watch: {
    $route(_new) {
      if (_new.path == "/buyer/shoppingList") this.getData();
    }
  },
  created() {
    if (this.$route.path == "/buyer/shoppingList") this.getData();
    document.title = "51 AUTOPARTS 我的零件清单";
  },
  methods: {
    detail(id) {
      this.$router.push(this.$route.path + "/" + id);
    },
    close() {
      this.showDialog = false;
    },
    save() {
      this.$list("/bhome/favCols/save", {
        name: this.listName,
        description: this.listDescribe
      })
        .then(res => {
          this.listName = "";
          this.listDescribe = "";
          this.$refs.dialog.close();
          this.getData();
        })
        .catch(err => {});
    },
    getData() {
      this.$list("/bhome/favCols/query", {})
        .then(res => (this.records = res))
        .catch(err => {});
    },
    remove(id) {
      $alert({
        type: "remove",
        title: "确定删除吗？",
        text: "一旦删除将无法恢复，请确定是否继续。",
        ok: () => {
          this.$list("/bhome/favCols/destroy/" + id, {})
            .then(res => this.getData())
            .catch(err => {});
        }
      });
    }
  }
};
</script>

<style lang="less">
.ap-shopping-list {
  .title {
    margin-bottom: 20px;
    font-size: 24px;
  }
  .table {
    tbody {
      color: #666;
    }
    td {
      vertical-align: middle;
    }
    tr {
      cursor: pointer;
      &:hover {
        background: #f2f2f2;
      }
    }
  }
}
.dialog-item {
  display: flex;
  padding: 15px;
  .name {
    width: 80px;
    line-height: 36px;
  }
}
</style>